import type { CSSProperties } from 'react';

/**
 * Inline style for a button's busy state. Lives here rather than beside
 * `ButtonSpinner` because a file that exports both a component and a plain
 * function breaks Fast Refresh (react-refresh/only-export-components).
 *
 * `disabled` stays on a busy button, because it is what stops a second submit
 * from an Enter key or a double tap — `pointer-events: none` alone does not.
 * But `disabled` is also what triggers the `disabled:opacity-*` greying, and
 * Apple's loading state does not dim. So busy forces opacity back to 1 inline,
 * where it beats the class. Validation greying is untouched: a button disabled
 * because the form is incomplete still dims, which is correct.
 *
 * See section 8.3b of docs/DESIGN_SYSTEM.md.
 */
export function busyStyle(busy: boolean): CSSProperties | undefined {
  return busy ? { opacity: 1, pointerEvents: 'none' } : undefined;
}
